import React, { useEffect, useState } from 'react';
import VendorStats, { VendorStatsType } from './vendor-stats';
import VendorDetails from './vendor-details';
import { BankAltIcon, RmxNumberIcon, PhoneIcon, UserIcon, EditAltIcon } from 'cokitchen-icons';
import StoreItems from './store-items';
import TransactionHistory from './transaction-history';
import useDashboardContext from 'contexts/dashboard.context';
import PageHeaderText from 'components/base/page-header-text';
import useVendorContext from 'contexts/vendor.context';
import { VendorType } from 'models/vendors.model';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { formatDate } from 'utils/functions';
import ArchiveModal from 'components/modals/archive-vendor-modal';

const VendorProfile = () => {
  const { activeVendorProfile, setVendorToEdit } = useVendorContext();
  const router = useNavigate();
  const [archiveVendorId, setArchiveVendorId] = useState<string[]>([]);
  const [archiveVendorName, setArchiveVendorName] = useState<string>('');

  const vendorStatsArray: VendorStatsType[] = [
    {
      title: 'Total due',
      value: activeVendorProfile.outstanding
    },
    {
      title: 'amount paid',
      value: activeVendorProfile.total_paid
    },
    {
      title: 'outstanding',
      value: activeVendorProfile.outstanding
    }
  ];

  const vendorDetailsArray = [
    {
      icon: <PhoneIcon />,
      label: 'Phone number',
      value: activeVendorProfile.phone_number
    },
    {
      icon: <BankAltIcon />,
      label: 'Bank account',
      value: activeVendorProfile.bank_name
    },
    {
      icon: <RmxNumberIcon />,
      label: 'Account number',
      value: activeVendorProfile.account_number
    },
    {
      icon: <UserIcon />,
      label: 'Account name',
      value: activeVendorProfile.account_name
    }
  ];

  const { setIsBackLink } = useDashboardContext();
  useEffect(() => {
    setIsBackLink(true);
    return () => {
      setIsBackLink(false);
    };
  }, []);

  const editVendor = (vendor: VendorType) => {
    setVendorToEdit(vendor);
    router(`/main-store/vendors/${MAIN_STORE_ROUTE_KEYS.EDIT_VENDOR_DETAILS}`);
  };

  const handleArchive = () => {
    setArchiveVendorId([activeVendorProfile.id]);
    setArchiveVendorName(activeVendorProfile.name);
  };

  const handleArchiveSuccess = () => {
    setArchiveVendorId([]);
    router('/main-store/vendors');
  };

  return (
    <div>
      <div>
        <div className='flex justify-between'>
          <PageHeaderText
            title={activeVendorProfile.name}
            description={`Created ${formatDate(activeVendorProfile.created_at)}`}
          />
          <div className='flex gap-3'>
            <button
              className='flex justify-center gap-1 h-fit items-center w-[80px] mx-auto bg-[#F2F2F2] rounded-[6px] py-[7px] text-[#5E6164]'
              onClick={() => editVendor(activeVendorProfile)}>
              <EditAltIcon /> Edit
            </button>
            <button
              onClick={handleArchive}
              className='w-[80px] mx-auto border h-fit border-[#E60A2B] rounded-[6px] py-[7px] text-[#E60A2B]'>
              Archive
            </button>
          </div>
        </div>
        <div className='space-y-8'>
          <VendorStats list={vendorStatsArray} />

          <div className='flex flex-col max-h-[400px] md:flex-row gap-4'>
            <div className='flex-1 overflow-y-auto'>
              <VendorDetails list={vendorDetailsArray} />
            </div>
            <div className='flex-1 overflow-y-auto '>
              <StoreItems />
            </div>
          </div>
          <TransactionHistory />
        </div>
      </div>
      {archiveVendorId.length > 0 && (
        <ArchiveModal
          show
          onClose={() => setArchiveVendorId([])}
          vendorIds={archiveVendorId}
          vendorName={archiveVendorName}
          onSuccess={handleArchiveSuccess}
        />
      )}
    </div>
  );
};

export default VendorProfile;
